import { Theme, ThemeUICSSObject, spacing } from '@apia/theme';
/* IMPORT HERE */

export const rankingUsers: (theme: Theme) => ThemeUICSSObject = (theme) => {
  return {
    /* PREPEND HERE */
    ul: {
      border: '1px solid',
      borderColor: theme.palette.gray[800],
    },
    li: {
      borderBottom: '1px solid',
      borderColor: theme.palette.gray[800],
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      height: 'auto',
      gap: spacing(5),
      py: '5px',
      px: '20px',
      alignItems: 'center',

      img: {
        height: '40px',
        width: '40px',
        flexShrink: 0,
      },

      '.activeUser': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'baseline',
        gap: '5px',
        width: '65%',
        h6: { whiteSpace: 'normal' },
      },
      '.activeUser__stats': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'end',
        width: '20%',
      },
    },
  };
};
